const resources: {[id:string]: string } = {};

// this returns a function that will return the resource. Useful
// for lazy evaluation which can avoid the race condition
// that occurs sometimes when we try to use a resource before it has been added
export function getDeferred(key: string): () => string {
    return () => <string>get(key);
}

function _get(input: string): string {
    return resources[input] || input;
}

export function get<T extends string|string[]>(input: T): T {
    if(input instanceof Array) {
        return <T>(<string[]>input).map(key => _get(key));
    }

    if(typeof input === 'string') {
        return <T>_get(<string>input);
    }

    return input;
}

export function set(dict: {}): void {
    for (var p in dict) {
        if (dict.hasOwnProperty(p)) {
            resources[p] = dict[p];
        }
    }
}
